export const enum TripOverviewModalType {
  AccommodationUpsell = 'accommodationUpsell',
  AddFlights = 'addFlights',
  ConfirmationWarning = 'confirmationWarning',
  BookingError = 'bookingError',
  DestinationSelector = 'destinationSelector',
  EditTrip = 'editTrip',
  ExternalError = 'externalError',
  FerryDetails = 'ferryDetails',
  FerryFilters = 'ferryFilters',
  FerryMultipleVehicles = 'ferryMultipleVehicles',
  FlightDetails = 'flightDetails',
  FlightsFilters = 'flightFilters',
  HotelFilters = 'hotelFilters',
  None = 'none',
  PaxSelector = 'paxSelector',
  PortSelector = 'portSelector',
  PremadeTripDescription = 'premadeTripDescription',
  PriceGuarantee = 'priceGuarantee',
  ReloadPage = 'reloadPage',
  RemoveDestination = 'removeDestination',
  Sembonus = 'sembonus',
  TripCalendar = 'tripCalendar',
  TripPriceSummary = 'tripPriceSummary',
  WhyWeSuggest = 'whyWeSuggest',
  ConfirmRemoveAccommodation = 'confirmRemoveAccommodation',
  ConfirmRemoveFerry = 'confirmRemoveFerry',
  ConfirmRemoveActivity = 'confirmRemoveActivity',
  ConfirmRemoveFlight = 'confirmRemoveFlight',
  ConfirmRemoveSimpleTransport = 'confirmRemoveSimpleTransport',
}
